import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root', // Service wird global bereitgestellt
})
export class Helper {
  constructor() {}

  /**
   * Wandelt Minuten in Stunden um (Format: hh:mm)
   * @param minutes Anzahl der Minuten
   * @returns String im Format "hh:mm"
   */
  convertMinutesToHours(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}:${mins.toString().padStart(2, '0')}h`;
  }
}